<div class="text-override text-atom-component">
  <div [innerHTML]="content | safeHtml"></div>
</div>
